import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  segmentation: {
    status: 'idle',
    results: null
  },
  competitors: {
    status: 'idle',
    results: null
  },
  taskId: null,
  url: '',
  error: null,
  isLoading: false,
  errorMessage: ''
};

const initialAnalysisSlice = createSlice({
  name: 'initialAnalysis',
  initialState,
  reducers: {
    initiateAnalysis: (state, action) => {
      return {
        ...initialState,
        url: action.payload
      };
    },
    setCompetitorsForAnalysis: (state, action) => {
      state.competitors = action.payload.competitors;
      state.taskId = action.payload.taskId;
    },
    setAnalysisUrl: (state, action) => {
      state.url = action.payload;
      state.errorMessage = ''; // Clear any previous error
    },
    setAnalysisTaskId: (state, action) => {
      state.taskId = action.payload;
    },
    setAnalysisStatus: (state, action) => {
      const { segmentation, competitors } = action.payload;

      if (segmentation) {
        state.segmentation.status = segmentation.status;
        if (segmentation.results) {
          state.segmentation.results = segmentation.results;
        }
      }

      if (competitors) {
        state.competitors.status = competitors.status;
        if (competitors.results) {
          state.competitors.results = competitors.results;
        }
      }
    },
    setAnalysisError: (state, action) => {
      state.error = action.payload;
      state.errorMessage = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    resetAnalysis: () => {
      return initialState;
    }
  }
});

export const {
  initiateAnalysis,
  setCompetitorsForAnalysis,
  setAnalysisUrl,
  setAnalysisTaskId,
  setAnalysisStatus,
  setAnalysisError,
  setLoading,
  setErrorMessage,
  resetAnalysis
} = initialAnalysisSlice.actions;

export default initialAnalysisSlice.reducer;
